import { useState } from "react"

export const SiteStates = () => {
    const [promo, setPromo] = useState(null)

    return {
        promo: {data: promo, set: setPromo},
    }
}